<template>
  <div class="ball">
    <div class="ball-content" @click="showContact = true">
      <van-icon name="service"></van-icon>
      <p>联系老师</p>
    </div>

    <van-popup v-model="showContact" closeable round>
      <div class="conatct">
        <img src="https://files.zhuokao360.com/mall/qrcode.png" />
        <p>扫一扫联系你的<span class="em">专属老师</span></p>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: 'AuditBall',
    data() {
      return {
        showContact: false, // 是否显示联系老师
      };
    },
  };
</script>

<style lang="scss" scoped>
.ball-content {
  width: 60px;
  height: 60px;
  color: #fff;
  background-color: #37a5f0;
  text-align: center;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.ball-content .van-icon {
  margin-top: 6px;
  font-size: 24px;
  transform: scaleX(1.2);
}

.ball-content p {
  margin-top: 2px;
  font-size: 10px !important;
}

.conatct {
  padding: 40px 20px 20px;
  text-align: center;
}

.conatct p {
  margin-top: 5px;
  font-size: 14px;
  color: #666;
}

.conatct .em {
  display: inline-block;
  margin-left: 5px;
  color: red;
  animation: 1.5s infinite rotate;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
